const courses = [
  {
    id: 1,
    title: "The Complete 2021 Web Development Bootcamp",
    instructor: "Dr. Angela Yu",
    courseLogoPath: "mern.png",
    courseLogoAlt: "mern",
    providerLogoPath: "udemy.png",
    providerLogoAlt: "udemy",
  },
  {
    id: 2,
    title: "React - The Complete Guide (incl Hooks, React Router, Redux)",
    instructor: "Academind by Maximilian Schwarzmüller",
    courseLogoPath: "react.svg",
    courseLogoAlt: "react",
    providerLogoPath: "udemy.png",
    providerLogoAlt: "udemy",
  },
  {
    id: 3,
    title: "Understanding TypeScript - 2022 Edition",
    instructor: "Maximilian Schwarzmüller",
    courseLogoPath: "typescript.svg",
    courseLogoAlt: "typescript",
    providerLogoPath: "udemy.png",
    providerLogoAlt: "udemy",
  },
  {
    id: 4,
    title: "Accelerated ES6 JavaScript Training",
    instructor: "Maximilian Schwarzmüller",
    courseLogoPath: "es6.svg",
    courseLogoAlt: "es6",
    providerLogoPath: "udemy.png",
    providerLogoAlt: "udemy",
  },
  {
    id: 5,
    title: "Testing React with Jest and Testing Library",
    instructor: "Bonnie Schulkin",
    courseLogoPath: "jest.svg",
    courseLogoAlt: "jest",
    providerLogoPath: "udemy.png",
    providerLogoAlt: "udemy",
  },
];

export default courses;
